import moment from 'moment';

export const text = (str) => {
  return str ? str.toString() : 'sin datos';
};

export const date = (str) => {
  if (!str) return 'No registra';
  return moment(str).format('YYYY-MM-DD');
};

export const datetime = (str) => {
  if (!str) return 'No registra';
  return moment(str).format('YYYY-MM-DD HH:mm:ss');
};
export const time = (str) => {
  if (!str) return 'No registra';
  return moment(str).format('HH:mm:ss');
};

export const number = (nStr) => {
  if (nStr == null) {
    return 'No registra';
  }
  nStr += '';
  const x = nStr.split('.');
  let x1 = x[0];
  const x2 = x.length > 1 ? `.${x[1]}` : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1,$2');
  }
  return x1 + x2;
};

export const money = (val) => {
  if (val == null) {
    return 'no registra';
  }
  const numVal = Number(val);
  if (!Number.isNaN(numVal)) {
    return `$${number(numVal.toFixed(2))}`;
  }
  return val;
};

export const boolean = (value) => {
  return value ? 'SI' : 'NO';
};

export const transactionType = (value) => {
  return value === 'topUp' ? 'Recarga' : 'paquete';
};
export const status = (value) => {
  return value === 'SUCCESS' ? <div className="text-green-800">Exitosa</div> : value === 'ERROR' ?
    <div className="text-red-800">Error</div> : <div className="text-blue-800">Procesando</div>;
};

export const image = (value) => {
  return <img src={value} width={80}/>;
};

export default {
  text,
  date,
  datetime,
  number,
  money,
  cash: money,
  boolean,
  time,
  image,
  status,
  transactionType
};
